import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=0edf8b16&scoped=true"
import script from "./editTable.vue?vue&type=script&lang=js"
export * from "./editTable.vue?vue&type=script&lang=js"
import style0 from "./editTable.vue?vue&type=style&index=0&id=0edf8b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf8b16",
  null
  
)

export default component.exports